import { Link } from "react-router-dom"
import SmartCard from "./SmartCard"
import NewCard from "./NewCard"
import "./SmartCardList.css"
import { useUser } from "../../../contexts/UserContext"

const SmartCardList = ({ smartCards, newCard, onManageCard }) => {
    const { getToken, isAdmin, isReadOnly } = useUser()


    return (
        <>
            {(
                <div className="card-list">
                    {smartCards.map((card, i) =>
                        card.status === 3 ? (
                            <SmartCard onManageCard={onManageCard} key={i} card={card} isOffline />
                        ) : (
                            
                                <SmartCard onManageCard={onManageCard} card={card} />
                        )
                        )}
                    {(isAdmin || isReadOnly) && (<NewCard onClick={newCard}></NewCard>)}
                        
                </div>
            )}
        </>
    )
}

export default SmartCardList
